(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-fv-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bind(root) {
    if (!root || root.dataset.cfvsBound || !window.jQuery) return;
    var sliderEl = root.querySelector('[data-js-slider-slick]');
    var thumbs = root.querySelectorAll('[data-cfvs-thumb]');
    if (!sliderEl || !thumbs.length) return;
    var $slick = window.jQuery(sliderEl);
    if (!$slick.hasClass('slick-initialized')) return;
    root.dataset.cfvsBound = '1';

    function setActive(index) {
      thumbs.forEach(function (t, i) {
        var on = i === index;
        t.classList.toggle('is-active', on);
        if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        $slick.slick('slickGoTo', +t.getAttribute('data-cfvs-thumb'));
      });
    });
    $slick.on('beforeChange', function (e, slick, current, next) {
      setActive(next);
    });
    setActive($slick.slick('slickCurrentSlide'));
  }

  function watch(root) {
    // テーマが slick を初期化し終えると builder-section に section:loaded が飛ぶ
    root.addEventListener('section:loaded', function () { bind(root); });
    bind(root); // すでに初期化済みの場合
  }

  function init() {
    document.querySelectorAll('[data-cfvs]').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-cfvs]');
    if (root) watch(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
